import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import IncidentIndicator from '../common/components/IncidentIndicator';

export const buildRetailHeader = (headersProps, retailProps) => {
    let { shortStoreName, storeName, storeId } = retailProps;
    return (
        <div className='retailer-incident-header'>
            <span id={"retail-" + storeId}>
                {shortStoreName ?
                    <UncontrolledTooltip placement='top' boundariesElement='window' className="retailer-header-tooltip" delay={0} target={"retail-" + storeId} >
                        {storeName}
                    </UncontrolledTooltip> : null}
                <span>{shortStoreName}</span>
            </span>
             <IncidentIndicator storeId={storeId}/>       
        </div>
    );
}
